import { useRecoilValue } from 'recoil';

import { authSelector } from '@/components/state/auth/AuthState';

export const useAuth = () => useRecoilValue(authSelector);
